// Instead of the list being generated by the getListItemData(), this function creates the list of options after a selection is made.
// It loops through the full list of options that are 'selected' and then displays them as selected.
//
// For persistent search, we are waiting to update the listDataArray in the handleOptionsArrays() function and instead updating it
// within this function. This allows us to display the filtered list of items after a selection has been made.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNotNilOrEmpty } from '@pcty/utils';
import { getValueFromFlatArray } from './flattenedOptions';
import { isNumber } from './helpers';
export var handleIsSelected = function (flatOpt, flatVal, optionIndexMap, propsValue, primaryKey, isMulti, value, persistedInputValue, listDataArray, setListDataArray, setValue, setFlattenedOptions) {
    var _a;
    var newVal = getValueFromFlatArray(flatOpt, optionIndexMap, flatVal ? flatVal : propsValue, primaryKey);
    if (newVal && isMulti && !Array.isArray(newVal)) {
        newVal = [newVal];
    }
    else if (isMulti && !newVal && !Array.isArray(newVal)) {
        newVal = [];
    }
    // deselect all previously selected
    if (Array.isArray(value)) {
        for (var i = 0; i < flatOpt.length; i++) {
            flatOpt[i].selected = false;
        }
    }
    else if (value && !Array.isArray(value) && isNumber(value.optionsIndex) && flatOpt[value.optionsIndex]) {
        flatOpt[value.optionsIndex].selected = false;
    }
    // select all new selections
    if (newVal && isNotNilOrEmpty(newVal)) {
        if (!isMulti && !Array.isArray(newVal) && isNumber(newVal.optionsIndex) && flatOpt[newVal.optionsIndex]) {
            flatOpt[newVal.optionsIndex].selected = true;
        }
        else if (Array.isArray(newVal)) {
            for (var i = 0; i < newVal.length; i++) {
                if (!newVal[i])
                    continue;
                var index = newVal[i].optionsIndex;
                if (isNumber(index))
                    flatOpt[index].selected = true;
            }
            if (persistedInputValue) {
                var persistFlatOpt = listDataArray.filter(function (opt) { return !opt.creatable; });
                for (var i = 0; i < persistFlatOpt.length; i++) {
                    persistFlatOpt[i].selected = false;
                }
                var _loop_1 = function (i) {
                    if (((_a = newVal === null || newVal === void 0 ? void 0 : newVal[i]) === null || _a === void 0 ? void 0 : _a.optionsIndex) !== undefined) {
                        persistFlatOpt = persistFlatOpt.map(function (opt) {
                            return opt.optionsIndex === (newVal === null || newVal === void 0 ? void 0 : newVal[i].optionsIndex) ? __assign(__assign({}, opt), { selected: true }) : __assign({}, opt);
                        });
                    }
                };
                for (var i = 0; i < newVal.length; i++) {
                    _loop_1(i);
                }
                setListDataArray(persistFlatOpt);
            }
        }
    }
    setValue(newVal);
    setFlattenedOptions(flatOpt);
};
